module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/coj_e-2-9a8a6445475c4a7cdd061f5c28d7e031.jpg";